import * as React from 'react';
import { ReactComponent as NoEntryIcon } from '../assets/icons/no-entry.svg';

export default function UnauthorizedPage() {
  return (
    <div className="flex flex-col items-center justify-center h-full min-h-screen p-6 bg-allstate-blue">
      <div className="flex flex-col justify-center gap-4 px-6 py-10 text-center bg-white rounded-lg max-w-[640px]">
        <div className="flex justify-center">
          <NoEntryIcon className="text-allstate-blue w-[40px] h-[40px]" />
        </div>
      
        <div className="flex flex-col gap-4">
          <h1 className="text-xl font-medium">Access denied</h1>
          <p className="m-0">You do not have permission to access this page.</p>
        </div>

        <div className="px-6 py-4 text-left border rounded-lg text-grey-8 bg-grey-2 border-grey-4">
          <h2 className="font-bold uppercase">What happened?</h2>
          <p>Accounts are restricted from directly accessing the rate relief calculator for security purposes. Please
          speak with the designated account admin to request access.</p>
        </div>
      </div>
    </div>
  );
}